export default __webpack_public_path__ + "static/media/CDH_logo_Primary.c4b1982f.png";